export const resorts = [
    {
        textField: "Disney's All-Star Movies Resort",
        valueField: "Disney's All-Star Movies Resort",
    },
    {
        textField: "Disney's All-Star Sports Resort",
        valueField: "Disney's All-Star Sports Resort",
    },
    {
        textField: "Disney's All-Star Music Resort",
        valueField: "Disney's All-Star Music Resort",
    },
    {
        textField: "Disney's Pop Century Resort",
        valueField: "Disney's Pop Century Resort",
    },
    {
        textField: "Disney's Art of Animation Resort",
        valueField: "Disney's Art of Animation Resort",
    },
    {
        textField: "Disney's Caribbean Beach Resort",
        valueField: "Disney's Caribbean Beach Resort",
    },
];
